import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DESTINATIONS = [
  {
    name: 'Srinagar', tag: 'City & Lakes', season: 'Mar–Nov',
    img: 'https://images.unsplash.com/photo-1719423521976-2fea6202adbc?w=800&q=80',
    desc: 'The summer capital of J&K — home to the iconic Dal Lake, Mughal Gardens, and centuries of Kashmiri culture.',
    highlights: ['Dal Lake Shikara Ride','Mughal Gardens','Shankaracharya Temple','Lal Chowk Market','Houseboats'],
    packages: 12,
  },
  {
    name: 'Gulmarg', tag: 'Snow & Skiing', season: 'Oct–Apr',
    img: 'https://images.unsplash.com/photo-1627894485200-b92fb4353967?w=800&q=80',
    desc: 'The "Meadow of Flowers" — home to the world\'s highest Gondola and India\'s premier ski resort.',
    highlights: ['Gondola Cable Car','Ski Resort','Alpather Lake','Biosphere Reserve','Snow Sports'],
    packages: 8,
  },
  {
    name: 'Pahalgam', tag: 'Valley & Trekking', season: 'Apr–Oct',
    img: 'https://images.unsplash.com/photo-1661747340818-df15f186554e?w=800&q=80',
    desc: 'The "Valley of Shepherds" along the Lidder River — gateway to Amarnath and renowned for its lush meadows.',
    highlights: ['Betaab Valley','Aru Valley','Chandanwari','Baisaran Meadow','Lidder River'],
    packages: 7,
  },
  {
    name: 'Sonamarg', tag: 'Glaciers & Adventure', season: 'May–Oct',
    img: 'https://images.unsplash.com/photo-1706628416838-0325e29521ee?w=800&q=80',
    desc: 'The "Meadow of Gold" — a high-altitude paradise gateway to the Sindh Valley and Thajiwas Glacier.',
    highlights: ['Thajiwas Glacier','Sindh River','Zero Point','Zoji La Pass','Meadows Trek'],
    packages: 5,
  },
  {
    name: 'Leh-Ladakh', tag: 'High Altitude', season: 'Jun–Sep',
    img: 'https://images.unsplash.com/photo-1635255506105-b74adbd94026?w=800&q=80',
    desc: 'The "Land of High Passes" — a moonscape plateau with turquoise lakes, ancient monasteries, and Bactrian camels.',
    highlights: ['Pangong Lake','Khardung La','Nubra Valley','Thiksey Monastery','Magnetic Hill'],
    packages: 6,
  },
  {
    name: 'Doodhpathri', tag: 'Hidden Gem', season: 'Apr–Sep',
    img: 'https://images.unsplash.com/photo-1623612175509-30e97f5aa195?w=800&q=80',
    desc: 'The "Valley of Milk" — a pristine alpine meadow with milky white streams and pine forests largely untouched by tourism.',
    highlights: ['Alpine Meadows','Pine Forests','Milky Streams','Wildlife Spotting','Photography'],
    packages: 3,
  },
  {
    name: 'Yusmarg', tag: 'Pine Forest Retreat', season: 'Mar–Oct',
    img: 'https://images.unsplash.com/photo-1621232082074-1a7750ecc557?w=800&q=80',
    desc: 'A serene meadow surrounded by dense pine and fir forests — perfect for nature walks and tranquil escapes.',
    highlights: ['Pine Forest Walks','Tosa Maidan','Horse Riding','Nilnag Lake','Camping'],
    packages: 4,
  },
  {
    name: 'Gurez Valley', tag: 'Off the Beaten Path', season: 'Jun–Sep',
    img: 'https://images.unsplash.com/photo-1643449416258-5c8e7ec598b1?w=800&q=80',
    desc: 'One of India\'s most remote valleys — jagged mountain peaks, Kishanganga River, and ancient Dard architecture.',
    highlights: ['Kishanganga River','Habba Khatoon Peak','Dawar Village','Trout Fishing','Stargazing'],
    packages: 2,
  },
];

export default function Destinations() {
  const [active, setActive] = useState(null);

  return (
    <div>
      {/* Hero */}
      <div className="page-hero" style={{ paddingBottom:'5rem', backgroundImage:"url('https://images.unsplash.com/photo-1623612175509-30e97f5aa195?w=1600&q=85')" }}>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="breadcrumb">
            <Link to="/">Home</Link><span className="breadcrumb-sep">›</span><span>Destinations</span>
          </div>
          <h1>Explore Kashmir's<br/><span style={{ fontStyle:'italic', color:'var(--accent)' }}>Hidden Wonders</span></h1>
          <p>From the shimmering Dal Lake to the moon landscapes of Ladakh — every corner of this valley holds magic waiting to be discovered.</p>
        </div>
      </div>

      <section className="section" style={{ background:'var(--bg)', paddingTop:'3rem' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(320px, 1fr))', gap:'2rem' }}>
            {DESTINATIONS.map((dest, i) => (
              <div key={i}
                style={{ background:'var(--surface)', borderRadius:'var(--radius-lg)', overflow:'hidden', boxShadow:'var(--shadow-sm)', transition:'all 0.3s', cursor:'pointer', border: active === i ? '2px solid var(--secondary)' : '2px solid transparent' }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-8px)'; e.currentTarget.style.boxShadow='var(--shadow-xl)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='var(--shadow-sm)'; }}
                onClick={() => setActive(active === i ? null : i)}>
                <div style={{ position:'relative', height:240, overflow:'hidden' }}>
                  <img src={dest.img} alt={dest.name} loading="lazy" style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.6s' }} />
                  <div style={{ position:'absolute', inset:0, background:'linear-gradient(180deg, transparent 40%, rgba(16,37,66,0.90) 100%)' }} />
                  <div style={{ position:'absolute', top:'1rem', left:'1rem' }}>
                    <span className="badge badge-white">{dest.tag}</span>
                  </div>
                  <div style={{ position:'absolute', top:'1rem', right:'1rem' }}>
                    <span style={{ background:'rgba(246,196,83,0.90)', color:'var(--dark)', padding:'0.25rem 0.65rem', borderRadius:100, fontSize:'0.72rem', fontWeight:700, fontFamily:"'Poppins',sans-serif" }}>🕐 {dest.season}</span>
                  </div>
                  <div style={{ position:'absolute', bottom:'1rem', left:'1.25rem', right:'1.25rem' }}>
                    <h3 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", fontSize:'1.5rem', margin:0 }}>{dest.name}</h3>
                    <p style={{ color:'rgba(255,255,255,0.80)', fontSize:'0.82rem', margin:'0.2rem 0 0' }}>{dest.packages} packages available</p>
                  </div>
                </div>
                <div style={{ padding:'1.5rem' }}>
                  <p style={{ fontSize:'0.9rem', lineHeight:1.75, color:'var(--body)', marginBottom:'1rem' }}>{dest.desc}</p>
                  {/* Highlights */}
                  <div style={{ marginBottom:'1.25rem' }}>
                    <div style={{ fontSize:'0.75rem', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.08em', color:'var(--primary)', marginBottom:'0.6rem', fontFamily:"'Poppins',sans-serif" }}>Top Attractions</div>
                    <div style={{ display:'flex', flexWrap:'wrap', gap:'0.4rem' }}>
                      {dest.highlights.map((h,j) => (
                        <span key={j} style={{ padding:'0.25rem 0.6rem', background:'rgba(15,76,129,0.08)', color:'var(--primary)', borderRadius:100, fontSize:'0.75rem', fontWeight:600, fontFamily:"'Poppins',sans-serif" }}>✦ {h}</span>
                      ))}
                    </div>
                  </div>
                  <Link to={`/tours?destination=${dest.name}`} className="btn btn-primary btn-sm w-full" style={{ justifyContent:'center' }}>
                    View {dest.packages} Packages →
                  </Link>
                </div>
              </div>
            ))}
          </div>

          {/* Custom Package */}
          <div style={{ marginTop:'4rem', background:'linear-gradient(135deg,#102542,#0F4C81)', borderRadius:'var(--radius-xl)', padding:'3.5rem', textAlign:'center', position:'relative', overflow:'hidden' }}>
            <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse at 70% 50%, rgba(58,175,169,0.20) 0%, transparent 65%)' }} />
            <div style={{ position:'relative', zIndex:1 }}>
              <h2 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", marginBottom:'0.75rem' }}>Have a destination in mind?</h2>
              <p style={{ color:'rgba(255,255,255,0.80)', maxWidth:480, margin:'0 auto 2rem', lineHeight:1.7 }}>Tell us where you want to go and we'll craft the perfect itinerary around your dream destinations.</p>
              <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
                <Link to="/contact" className="btn btn-accent btn-lg">Plan My Trip</Link>
                <a href="https://wa.me/917006478276" target="_blank" rel="noopener noreferrer" className="btn btn-outline-white btn-lg">💬 WhatsApp</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <a href="https://wa.me/917006478276" target="_blank" rel="noopener noreferrer" className="whatsapp-fab">💬</a>
    </div>
  );
}
